import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RoutesWeb } from 'src/shared/interfaces/routes';
import { WrapMain } from 'src/shared/modules/wrap_main'
import { gerenciaTecnicaSlice, selectGtoState, useDispatch } from 'src/stateManagement/redux';
import { StandAloneReportViewer } from 'src/tecnica/modules/reports_viewer/reportsViewer';

export const ConsolidateCards = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const mainState = useSelector(selectGtoState);

  useEffect(() => {

    const filters = mainState.reportFilters;
    const report = mainState?.reportFilters?.activeReport;

    if (!report || !filters) {
      handleGoToDashboard();
    } 

  }, [mainState.reportFilters])

  const handleGoToDashboard = () => {
    dispatch(gerenciaTecnicaSlice.actions.emptyReportData());
    navigate('/gto/dashboard')
  }

  return (
    <WrapMain>
      <StandAloneReportViewer report={mainState.reportFilters?.activeReport} onClose={handleGoToDashboard} filters={mainState.reportFilters} />
    </WrapMain>
  )
}
